import React, { useContext } from 'react';
import clsx from 'clsx';
import HotelRoomTravelers from '../HotelRoomTravelers/HotelRoomTravelers';
import HotelLocations from '../HotelLocations/HotelLocations';
import HotelDateRange from '../HotelDateRange/HotelDateRange';
import SearchButton from './SearchButton/SearchButton';
import HotelsContext from '../../context/hotelsContext';
import styles from './HotelsSearchBody.scss';

const HotelsSearchBody = () => {
  const {
    config: {
      isMosaicDesign = false,
      shouldDisableMosaicFullscreenMobile = false,
    },
  } = useContext(HotelsContext);

  const showFullScreenMobile = isMosaicDesign && !shouldDisableMosaicFullscreenMobile;

  return (
    isMosaicDesign
      ? (
        <div className={clsx('row margin-0', showFullScreenMobile && styles.fullscreenMobileStyles)}>
          <div className={clsx(styles.locationsWrapper, 'margin-0 col-xs-12 col-sm-6 col-lg-3', showFullScreenMobile && 'pad-t-xs-down')}>
            <HotelLocations />
          </div>
          <div className={clsx(styles.roomsWrapper, 'margin-0 col-xs-12 col-sm-6 col-lg-3')}>
            <HotelRoomTravelers />
          </div>
          <div
            data-testId="date-range-wrapper"
            className={clsx(styles.datesWrapper, 'flex flex-row flex-item-grow margin-0 col-sm-12 col-lg-6', !showFullScreenMobile && 'flex-column-xs-down')}
          >
            <div className="flex-item-grow">
              <HotelDateRange />
            </div>
            <div
              className={showFullScreenMobile
                ? clsx(styles.fullScreenSearchBtnWrapper, 'border-t width-full pad-2-xs-down')
                : clsx(styles.searchBtnWrapper, 'pad-t-xs-down pad-l-sm-up')}
            >
              <SearchButton />
            </div>
          </div>
        </div>
      )
      : (
        <div className="pad">
          <HotelRoomTravelers />
          <div className="row flex-align-end">
            <div className="col-xs-12 col-md-7 pad-1-b-sm-down pad-0-r-md-up col-xl-8">
              <HotelLocations />
            </div>
            <div className="col-xs-12 col-md-4 col-xl-3 pad-0-r pad-b-sm-down">
              <HotelDateRange />
            </div>
            <div className="col-md-1 col-xs-12 margin-b-sm-down pad-0-l-md-up">
              <SearchButton />
            </div>
          </div>
        </div>
      )
  );
};

export default HotelsSearchBody;
